import {EditorContent} from '@tiptap/react';
import React, {ReactElement} from 'react';
import './staticText.css';
import {DeviceType} from '../../../incase-domain/common/DeviceType.enum';
import {IElementStaticText} from '../../../incase-domain/elements/staticText';
import {getBorderStyle} from '../../../utils/style.utils';
import {useGetEditor} from '../tipTap/getEditor';
import TextSelectionFloatingToolbar from '../tipTap/toolbar/TextSelectionFloatingToolbar';

interface ElementStaticTextComponentProps {
    element: IElementStaticText;
    device?: DeviceType;
}

function ElementStaticTextComponent(props: ElementStaticTextComponentProps): ReactElement {
    const {element, device = DeviceType.DESKTOP} = props;

    const {editor, handleDoubleClick, handleBlur, handleClick} = useGetEditor({id: element.id, element});

    return (
        <div
            id={element.id}
            style={getElementStyle(device, element)}
            className={`${getElementClasses(device)} ${editor && editor.isFocused ? 'is-active' : ''}`}
            onDoubleClick={(e) => handleDoubleClick(e)}
            onClick={handleClick}
        >
            <EditorContent editor={editor} onBlur={handleBlur} />
            <TextSelectionFloatingToolbar editor={editor} />
        </div>
    );
}

export function getElementStyle(device: DeviceType, element: IElementStaticText): React.CSSProperties {
    if (device === DeviceType.MOBILE) {
        return {
            color: element.font.color,
            backgroundColor: element.color,
            fontFamily: element.fontFamily?.name,
            borderRadius: getBorderStyle(element.borderRadius),
        };
    }

    return {
        fontSize: `${element.font.size || 2}em`,
        color: element.font.color,
        backgroundColor: element.color,
        fontFamily: element.fontFamily?.name,
        borderRadius: getBorderStyle(element.borderRadius),
    };
}

export function getElementClasses(device: DeviceType): string {
    if (device === DeviceType.MOBILE) {
        return 'c-tiptap c-textElement c-textElement--mobile ql-editor ql-editor--mobile';
    }

    return 'c-tiptap c-textElement ql-editor';
}

export default ElementStaticTextComponent;
